/** Query param que enciende el modo planificador (`?planner=1`), lo pone el canal del CMS. */
export const PLANNER_MODE_QUERY_PARAM = 'planner';

/** Clave con la que se persiste el modo planificador. */
export const PLANNER_MODE_STORAGE_KEY = 'planner-mode-enabled';

/**
 * T10797: el modo planificador caduca a los 10 minutos.
 *
 * Antes se guardaba sin caducidad y nada lo borraba, así que quien entraba una vez
 * —por el QR de un tótem o desde su propio móvil— se quedaba dentro del planificador
 * para siempre: la portada de la app dejaba de ser accesible (el guard la redirige)
 * aunque el visitante ya no estuviese planificando nada.
 *
 * El plazo se renueva en cada navegación, así que no corta a quien lo está usando:
 * son 10 minutos SIN actividad.
 */
export const PLANNER_MODE_TTL_SECONDS = 10 * 60;
